import { render, staticRenderFns } from "@/components/Layout/Menu/Websocket/Websocket.html?vue&type=template&id=22fae904&scoped=true&"
import script from "@/components/Layout/Menu/Websocket/Websocket.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Websocket/Websocket.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Websocket/Websocket.css?vue&type=style&index=0&id=22fae904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fae904",
  null
  
)

export default component.exports